<template>
  <div>
    <div v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <h4 style="margin-top:0px">Clients</h4>
      </div>
      <div class="col-md-3 ml-auto" style="text-align:right; margin-right:15px;">
        <a href="/client/create" style="margin-top:25px;">+ Add New Client</a>
      </div>
    </div>
    <div v-if="clients !== null" class="card">
      <div style="margin:25px;margin-top: 0px;">
        <el-table :data="clients">
          <el-table-column property="businessName" label="NAME" style="width:200px;"></el-table-column>
          <el-table-column label="ACTIONS">
            <template slot-scope="props">
              <p-button
                @click="$router.push('/client/influencer-campaigns/'+props.row._id)"
                size="sm"
                type="info"
                round
                outline
                class="button-space"
              >Campaigns</p-button>
              <p-button
                @click="$router.push('/client/detail/'+props.row._id)"
                size="sm"
                type="info"
                round
                outline
                class="button-space"
              >Details</p-button>

              <p-button
                @click="$router.push('/client/update/'+props.row._id)"
                size="sm"
                type="info"
                round
                outline
                class="button-space"
              >Edit</p-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import { clientListLoadApi } from "@/config/appSettings";
import { Table, TableColumn, Card, Tooltip, Button, Modal } from "element-ui";
export default {
  data: () => ({
    loadingOverlay: false,
    clients: null
  }),
  name: "Clients",
  components: {
    Card,
    Modal,
    [Button.name]: Button,

    [Tooltip.name]: Tooltip
  },
  methods: {
    async loadClients() {
      try {
        this.loadingOverlay = true;
        let clientSearchUrl = `${clientListLoadApi}/?usertoken=${this.auth}&status=active`;
        let clientList = await axios.get(clientSearchUrl);
        console.log("CLIENT LIST LOAD RESULT: ", clientList);
        if (clientList.data.success === true) {
          this.clients = clientList.data.result;
          this.loadingOverlay = false;
        }
      } catch (err) {
        console.log(err);
      }
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadClients();
  }
};
</script>

<style scoped>
</style>